import { lazy } from "react";
import pathRoutes from "routes/pathRoutes";

const Birthday26LadingPage = lazy(() => import("./index"));

export const mbsBirthday26Route = [
  {
    page: Birthday26LadingPage,
    path: pathRoutes.extra.mbsBirthday26,
  },
];
